import Vue from 'vue'
import VueRouter from 'vue-router'
// import i18n from '../i18n/i18n'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: 'CTG Architecture',
    },
    component: Home,
  },
  {
    path: '/projectDetail',
    name: 'ProjectDetail',
    component: () => import('../views/ProjectDetail.vue'), // 项目详情页
    meta: {
      title: '详情页',
    }
  },
  {
    path: '/projectList',
    name: 'ProjectList',
    component: () => import('../views/ProjectList.vue'), // 项目列表
    meta: {
      title: 'PROJECTS 项目',
    }
  },
  {
    path: '/recommendList',
    name: 'RecommendList',
    component: () => import('../views/RecommendList.vue'), // 推荐列表
    meta: {
      title: '推荐项目',
    }
  },
  {
    path: '/newsList',
    name: 'NewsList',
    component: () => import('../views/NewsList.vue'), // 新闻列表
    meta: {
      title: 'EVENTS 事件',
    }
  },
  {
    path: '/newsDetail',
    name: 'NewsDetail',
    component: () => import('../views/NewsDetail.vue'), // 项目详情页
    meta: {
      title: '详情页',
      scrollToTop: true,
    }
    
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'), // 关于
    meta: {
      title: 'ABOUT 简介',
    }
  },
  {
    path: '/aboutDetail',
    name: 'AboutDetail',
    component: () => import('../views/AboutDetail.vue'), // 关于
    meta: {
      title: 'ABOUT 简介',
    }
  },
  {
    path: '/contect',
    name: 'Contect',
    component: () => import('../views/Contect.vue'), // 联系
    // beforeEnter: (to, from, next) => {
    //     toggleAboutFullScreen(); // 尝试进入全屏模式
    //     next(); // 继续路由跳转
    // },
    meta: {
      title: 'CONTECT 联系',
    }
  },

  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue'), // 开始开发者模式就跳转到404页面
    meta: {
      title: 'CTG Architecture'
    }
  },
  {
    path: '/cover',
    name: 'Cover',
    component: () => import('../views/Cover.vue'), // 关于
    meta: {
      title: 'CTG Architecture'
    }
  }

]


const router = new VueRouter({
  mode: 'hash',
  routes,
})

/**
 * 路由拦截判断页面是否需要登录权限处理
 */

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  next()
 
  
})

export default router
